// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface RequestRma {
    properties: {
        phone: string;
        name: string;
        email: string;
        urgencyOfResolution: string;
        serialNumber: string;
    };
}

const initialRequestRmaState: RequestRma = {
    properties: {
        phone: "",
        name: "",
        email: "",
        urgencyOfResolution: "",
        serialNumber: "",
    },
};

const reducer = {
    "xRequestRma/updateRequestRma": (
        draft: Draft<RequestRma>,
        action: {
            properties: {
                phone: string;
                name: string;
                email: string;
                urgencyOfResolution: string;
                serialNumber: string;
            };
        },
    ) => {
        typeof action?.properties?.phone === "string" && (draft.properties.phone = action?.properties?.phone);
        typeof action?.properties?.name === "string" && (draft.properties.name = action?.properties?.name);
        typeof action?.properties?.email === "string" && (draft.properties.email = action?.properties?.email);
        typeof action?.properties?.urgencyOfResolution === "string" &&
            (draft.properties.urgencyOfResolution = action?.properties?.urgencyOfResolution);
        typeof action?.properties?.serialNumber === "string" &&
            (draft.properties.serialNumber = action?.properties?.serialNumber);
    },
};

const xRequestRma = createTypedReducerWithImmer(initialRequestRmaState, reducer);

(reducers as any).xRequestRma = xRequestRma;

export type xRequestRmaState = {
    xRequestRma: RequestRma;
};

type xRequestRmaReducers = {
    phone: typeof xRequestRma;
    name: typeof xRequestRma;
    email: typeof xRequestRma;
    urgencyOfResolution: typeof xRequestRma;
    serialNumber: typeof xRequestRma;
};

export type xRequestRmaActions = Parameters<xRequestRmaReducers[keyof xRequestRmaReducers]>[1] | AnyAction;
